<p *ngFor="let item of cart?.items">{{ item | json }}</p>
<div class="button-bar">
  <button mat-stroked-button (click)="openCart()">View Cart</button>
  <button mat-flat-button color="primary" (click)="checkout()">Checkout</button>
</div>
